<template>
  <v-container mt="4">
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-btn fab elevation="2" class="mb-4" color="primary" @click="showForm = !showForm"
      ><v-icon> {{ showForm ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
    </v-btn>
    <div v-show="showForm">
      <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
        <v-card rounded="lg">
          <v-card-title>Add new payment information</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" lg="4">
                <v-menu ref="menu" v-model="menu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="date" label="Payment date" filled v-bind="attrs" v-on="on" :rules="requiredField" />
                  </template>
                  <v-date-picker ref="picker" v-model="date"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field filled label="Source" v-model="source" :rules="requiredField" />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field type="number" v-model="paidAmount" filled label="Paid amount" :rules="requiredField" />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field type="number" v-model="returnAmount" filled label="Return amount" :rules="requiredField" />
              </v-col>
              <v-col cols="12">
                <v-btn type="submit" color="primary" :disabled="!valid" rounded>Add Information</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </div>

    <div class="display-1 text-center mt-10">{{ memberDetails.name }}</div>
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card rounded="lg">
          <v-card-text>
            <member-information-table :tableInfo="memberDetails.CreditInfo" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <app-snackbar />
  </v-container>
</template>

<script>
import MemberInformationTable from '../components/MemberInformationTable.vue';
import { mapState } from 'vuex';
import { requiredField } from '../validations/FieldValidation';
import AppSnackbar from '../components/common/AppSnackbar.vue';

export default {
  components: { MemberInformationTable, AppSnackbar },
  data: () => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    formattedDate: '',
    paidAmount: '',
    returnAmount: '',
    menu: false,
    requiredField,
    showForm: false,
    source: '',
    valid: true,
  }),

  computed: {
    ...mapState(['memberDetails', 'isLoading']),
  },

  created() {
    this.$store.dispatch('getSingleMemberInformation', this.$route.params.id);
  },

  methods: {
    handleSubmit() {
      this.$store
        .dispatch('addNewInformationForMember', {
          _id: this.$route.params.id,
          date: this.date,
          through: this.source,
          paid_tk: parseInt(this.paidAmount) || 0,
          return_tk: parseInt(this.returnAmount) || 0,
        })
        .then(() => this.$refs.form.reset());
    },
  },
};
</script>

<style lang="scss" scoped></style>
